import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(() =>
  createStyles({
    '@global': {
      '*': {
        boxSizing: 'border-box',
        margin: 0
        // padding: 0 -> remove conflict with ck-editor
      },
      html: {
        '-webkit-font-smoothing': 'antialiased',
        '-moz-osx-font-smoothing': 'grayscale',
        height: '100%',
        width: '100%'
      },
      body: {
        height: '100%',
        width: '100%'
      },
      a: {
        textDecoration: 'none'
      },
      '#root': {
        height: '100%',
        width: '100%'
      },
      '.MuiCard-root': {
        // borderRadius: 0,
        // boxShadow: 'none',
        // border: '1px solid #e4e4e4'
      },
      // '.detail-description h2': {
      //   marginBottom: '10px'
      // },
      // '.detail-description p': {
      //   margin: '5px 0'
      // },
      // '.detail-description ol, .detail-description ul': {
      //   padding: 'revert'
      // },
      '.changelog-description .changelog-version': {
        paddingBottom: '.3em',
        borderBottom: '1px solid rgb(33,38,46)'
      },
      '.changelog-description ol, .changelog-description ul': {
        padding: 'revert'
      }
    }
  })
);

const GlobalStyles = () => {
  useStyles();

  return null;
};

export default GlobalStyles;
